/*
 * Collections : bouton "Voir plus de résultats" (snippets/collection-load-more.liquid).
 * Charge la page suivante via la Section Rendering API et ajoute ses produits à la grille,
 * puis met à jour la jauge, la pagination et l'URL (?page=N, conservée au rafraîchissement).
 * Sans JS, le bouton reste un lien vers la page suivante.
 */
(() => {
  const replaceFromResponse = (container, responseContainer, selector) => {
    const target = container.querySelector(selector);
    if (!target) return;
    const source = responseContainer.querySelector(selector);
    if (source) {
      target.replaceWith(source);
    } else {
      target.remove();
    }
  };

  const loadMore = async (button) => {
    const grid = document.getElementById('product-grid');
    if (!grid || button.getAttribute('aria-busy') === 'true') return;

    const pageUrl = new URL(button.href, window.location.origin);
    const fetchUrl = new URL(pageUrl);
    fetchUrl.searchParams.set('section_id', grid.dataset.id);

    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.loadingLabel;

    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const responseGrid = html.getElementById('product-grid');
      if (!responseGrid) throw new Error('#product-grid absent de la réponse');

      const newItems = Array.from(responseGrid.children);
      grid.append(...newItems);

      const container = grid.closest('.collection');
      const responseContainer = responseGrid.closest('.collection');
      replaceFromResponse(container, responseContainer, '[data-collection-load-more]');
      replaceFromResponse(container, responseContainer, '.pagination-wrapper');

      window.history.replaceState(window.history.state, '', pageUrl);

      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(grid);
      newItems[0]?.querySelector('a')?.focus({ preventScroll: true });
    } catch (error) {
      console.error(error);
      window.location.href = pageUrl.toString();
    }
  };

  // Délégation : la grille est re-rendue par les filtres (facets.js)
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-load-more]');
    if (!button) return;
    event.preventDefault();
    loadMore(button);
  });
})();
